export const COMPANY = {
    name: "Appex Smart Solution",
    tagline: "Smart Solutions for Your Home",
    address: "17 Ames Close, Luton, LU3 4AS",
    phoneDisplay: "07718 580408",
    phoneHref: "tel:+447718580408",
    phone2Display: "07438 192168",
    phone2Href: "tel:+447438192168",
    area: "Luton and surrounding areas",
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob21lJTIwa2l0Y2hlbiUyMHJlbm92YXRpb24lMjBpbnRlcmlvciUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3ODcwMTE5MzR8MA&ixlib=rb-4.1.0&q=85",
    about: "https://images.unsplash.com/photo-1505798577917-a65157d3320a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxwcm9wZXJ0eSUyMG1haW50ZW5hbmNlJTIwcGx1bWJpbmclMjBkZWNvcmF0aW5nJTIwcGFpbnRlciUyMHdvcmtlcnxlbnwwfHx8fDE3ODcwMTE5MzV8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
    {
        id: "property-maintenance",
        testid: "service-card-property-maintenance",
        title: "Property Maintenance",
        icon: "Wrench",
        desc: "General maintenance and repair solutions to keep homes and properties in excellent condition, all year round.",
        points: ["Repairs & upkeep", "Landlord & letting support", "Planned maintenance"],
    },
    {
        id: "painting-decorating",
        testid: "service-card-painting-decorating",
        title: "Painting & Decorating",
        icon: "PaintRoller",
        desc: "Interior and exterior painting, refreshing rooms and improving the appearance of properties.",
        points: ["Interior & exterior", "Clean, tidy finishes", "Colour refresh"],
    },
    {
        id: "plumbing",
        testid: "service-card-plumbing",
        title: "Plumbing",
        icon: "Droplets",
        desc: "General plumbing installation, maintenance and repair services for kitchens, bathrooms and heating-adjacent work.",
        points: ["Installations", "Leak & tap repairs", "Bathroom plumbing"],
    },
    {
        id: "unit-assembly",
        testid: "service-card-unit-assembly",
        title: "Unit Assembly & Installation",
        icon: "Package",
        desc: "Professional assembly and installation of furniture, storage units and household units.",
        points: ["Flat-pack furniture", "Storage & wardrobes", "Wall mounting"],
    },
    {
        id: "loft-extensions",
        testid: "service-card-loft-extensions",
        title: "Loft Extensions",
        icon: "HousePlus",
        desc: "Loft conversion and extension solutions to help homeowners make better use of their existing space.",
        points: ["Space planning", "Structural works", "Finishing touches"],
    },
    {
        id: "kitchen-installation",
        testid: "service-card-kitchen-installation",
        title: "Kitchen Unit Installation",
        icon: "CookingPot",
        desc: "Professional installation and fitting of kitchen units, cabinets and related components.",
        points: ["Unit & cabinet fitting", "Worktops", "Appliance spaces"],
    },
    {
        id: "smart-home-solutions",
        testid: "service-card-smart-home-solutions",
        title: "Smart Home & Property Solutions",
        icon: "Cpu",
        desc: "A flexible category for additional smart property services — talk to us about what your home needs next.",
        points: ["Tailored solutions", "Future services", "One trusted team"],
    },
];

export const BENEFITS = [
    { icon: "BadgeCheck", title: "Reliable & Professional", desc: "We turn up when we say we will, communicate clearly and treat every property with respect." },
    { icon: "Hammer", title: "Quality Workmanship", desc: "Every job, large or small, is completed to a standard we are proud to put our name to." },
    { icon: "MapPin", title: "Local Luton Service", desc: "Based in Luton, we serve homeowners, landlords and property managers across the local area." },
    { icon: "Lightbulb", title: "Practical Smart Solutions", desc: "We solve problems sensibly — practical fixes and improvements that make homes work better." },
    { icon: "Ruler", title: "Attention to Detail", desc: "From preparation to the final finish, the details are where we refuse to cut corners." },
    { icon: "FileText", title: "Free Quotes", desc: "Clear, no-obligation quotes so you know exactly what to expect before any work begins." },
];

export const GALLERY_CATEGORIES = [
    { id: "all", label: "All", testid: "gallery-filter-all" },
    { id: "painting", label: "Painting", testid: "gallery-filter-painting" },
    { id: "kitchens", label: "Kitchens", testid: "gallery-filter-kitchens" },
    { id: "plumbing", label: "Plumbing", testid: "gallery-filter-plumbing" },
    { id: "maintenance", label: "Maintenance", testid: "gallery-filter-maintenance" },
    { id: "loft-extensions", label: "Loft Extensions", testid: "gallery-filter-loft-extensions" },
    { id: "installations", label: "Installations", testid: "gallery-filter-installations" },
];

export const PROJECTS = [
    {
        id: 1, category: "painting", title: "Interior Room Refresh", location: "Luton, LU3",
        img: "https://images.unsplash.com/photo-1717281234297-3def5ae3eee1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxwcm9wZXJ0eSUyMG1haW50ZW5hbmNlJTIwcGx1bWJpbmclMjBkZWNvcmF0aW5nJTIwcGFpbnRlciUyMHdvcmtlcnxlbnwwfHx8fDE3ODcwMTE5MzV8MA&ixlib=rb-4.1.0&q=85",
        alt: "Painter refreshing interior walls during a painting and decorating project in Luton",
        desc: "Full interior redecoration: wall preparation, two-coat emulsion finish and crisp woodwork detail.",
    },
    {
        id: 2, category: "painting", title: "Exterior Woodwork Repaint", location: "Luton",
        img: "https://images.unsplash.com/photo-1505798577917-a65157d3320a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxwcm9wZXJ0eSUyMG1haW50ZW5hbmNlJTIwcGx1bWJpbmclMjBkZWNvcmF0aW5nJTIwcGFpbnRlciUyMHdvcmtlcnxlbnwwfHx8fDE3ODcwMTE5MzV8MA&ixlib=rb-4.1.0&q=85",
        alt: "Decorator repainting exterior woodwork on a Luton property",
        desc: "Exterior preparation, sanding and weather-resistant repainting of windows and doors.",
    },
    {
        id: 3, category: "kitchens", title: "Full Kitchen Renovation", location: "Luton, LU2",
        img: "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBob21lJTIwa2l0Y2hlbiUyMHJlbm92YXRpb24lMjBpbnRlcmlvciUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3ODcwMTE5MzR8MA&ixlib=rb-4.1.0&q=85",
        alt: "Modern kitchen renovation with new units installed in a Luton home",
        desc: "Complete kitchen strip-out and renovation with new units, worktops and finishing.",
    },
    {
        id: 4, category: "kitchens", title: "Kitchen Unit Fitting", location: "Luton, LU3",
        img: "https://images.pexels.com/photos/30924413/pexels-photo-30924413.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        alt: "Kitchen units and cabinets being fitted by installers in Luton",
        desc: "Precision fitting of kitchen cabinets, alignment, adjustments and finishing trims.",
    },
    {
        id: 5, category: "plumbing", title: "Bathroom Plumbing Repair", location: "Luton",
        img: "https://images.pexels.com/photos/5768187/pexels-photo-5768187.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        alt: "Plumber carrying out bathroom plumbing repairs in a Luton property",
        desc: "Diagnosis and repair of pipework, tap replacement and resealing.",
    },
    {
        id: 6, category: "maintenance", title: "Whole-Property Maintenance", location: "Luton, LU1",
        img: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob21lJTIwa2l0Y2hlbiUyMHJlbm92YXRpb24lMjBpbnRlcmlvciUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3ODcwMTE5MzR8MA&ixlib=rb-4.1.0&q=85",
        alt: "Refreshed interior after property maintenance work in Luton",
        desc: "Scheduled maintenance visit covering repairs, touch-ups and general upkeep.",
    },
    {
        id: 7, category: "loft-extensions", title: "Loft Conversion", location: "Luton, LU4",
        img: "https://images.unsplash.com/photo-1754063257992-bb9eabdbdd86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsb2Z0JTIwZXh0ZW5zaW9uJTIwaG91c2UlMjBjb25zdHJ1Y3Rpb24lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg3MDExOTM0fDA&ixlib=rb-4.1.0&q=85",
        alt: "Loft extension under construction on a house in Luton",
        desc: "Loft conversion creating a bright new living space within the existing roofline.",
    },
    {
        id: 8, category: "loft-extensions", title: "Loft Structural Works", location: "Luton",
        img: "https://images.unsplash.com/photo-1753893558279-8beaad18dd96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsb2Z0JTIwZXh0ZW5zaW9uJTIwaG91c2UlMjBjb25zdHJ1Y3Rpb24lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg3MDExOTM0fDA&ixlib=rb-4.1.0&q=85",
        alt: "Structural framing stage of a loft extension project in Luton",
        desc: "Structural framing and roof works for a loft extension, built to last.",
    },
    {
        id: 9, category: "installations", title: "Furniture & Storage Assembly", location: "Luton, LU3",
        img: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "Assembled living room furniture and storage units in a Luton home",
        desc: "Assembly and installation of flat-pack furniture and fitted storage units.",
    },
    {
        id: 10, category: "installations", title: "Shelving & Unit Installation", location: "Luton",
        img: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?crop=entropy&cs=srgb&fm=jpg&q=85",
        alt: "Installed shelving and household units in a refurbished Luton property",
        desc: "Wall-mounted shelving and household units, securely installed and levelled.",
    },
];

export const TESTIMONIALS = [
    {
        name: "Homeowner", location: "Luton, LU3", service: "Painting & Decorating",
        quote: "This is a placeholder testimonial. Real customer reviews will appear here once they have been collected from our clients.",
    },
    {
        name: "Landlord", location: "Luton, LU1", service: "Property Maintenance",
        quote: "This is a placeholder testimonial. We are gathering genuine feedback from homeowners, landlords and property managers we work with.",
    },
    {
        name: "Property Manager", location: "Luton, LU4", service: "Kitchen Installation",
        quote: "This is a placeholder testimonial. Check back soon to read what our customers say about working with Appex Smart Solution.",
    },
];

export const FAQS = [
    {
        q: "What areas do you cover?",
        a: "We are based in Luton and cover the whole town and surrounding areas. If you are nearby and unsure, just ask — we will let you know straight away.",
    },
    {
        q: "Do you provide free quotes?",
        a: "Yes. Every quote is free and comes with no obligation. Tell us about your project and we will give you a clear price before any work begins.",
    },
    {
        q: "What type of property maintenance do you offer?",
        a: "General repairs and upkeep for homes and rental properties — from small fixes and touch-ups to planned maintenance for landlords and property managers.",
    },
    {
        q: "Do you install kitchen units?",
        a: "Yes. We professionally fit kitchen units, cabinets, worktops and related components, making sure everything is level, aligned and finished neatly.",
    },
    {
        q: "Do you provide painting and decorating?",
        a: "Yes — interior and exterior painting and decorating, including wall preparation, emulsion, gloss work and full room refreshes.",
    },
    {
        q: "Can you help with loft extensions?",
        a: "Yes. We provide loft conversion and extension solutions that help you make better use of your existing space. Get in touch to discuss what is possible for your property.",
    },
    {
        q: "Can I request multiple services for the same property?",
        a: "Absolutely. Many customers combine services — for example maintenance, painting and unit installation in one visit. Mention everything you need in your enquiry and we will quote accordingly.",
    },
];

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const enquireAbout = (serviceTitle) => {
    window.dispatchEvent(new CustomEvent("prefill-service", { detail: serviceTitle }));
    scrollToId("contact");
};
